// Kontakt und Wunschtermin auf einer Seite (09.10.2026, vorher zwei Seiten).
// Steht nach den Fotos: Wer die Fotos gemacht hat, füllt die Formulare auch aus.

import { useState } from "react";
import { useNav } from "../Erfassung.tsx";
import { useDraft } from "../hooks.ts";
import { Footer } from "../ui/elemente.tsx";
import { KontaktFelder, kontaktFehler } from "./Kontakt.tsx";
import { TerminFelder, terminFehler } from "./Termin.tsx";

export function Angaben() {
  const d = useDraft();
  const { weiter, zurueck } = useNav();
  const [tried, setTried] = useState(false);
  const k = kontaktFehler(d.survey);
  const ok = !k.name && !k.reach && !terminFehler(d.survey);

  return (
    <>
      <h1>{d.company.privat ? "Ihre Kontaktdaten" : "Wie erreichen wir Sie?"}</h1>
      {d.company.demo && <p className="tip">Demo: Musterdaten sind schon eingetragen. Einfach weiter, oder ändern Sie, was Sie möchten.</p>}
      <KontaktFelder tried={tried} />
      <h2>Umzugstermin</h2>
      <TerminFelder tried={tried} />
      <Footer
        onBack={zurueck}
        onNext={() => {
          setTried(true);
          if (ok) weiter();
        }}
      />
    </>
  );
}
